import React, { Component } from 'react';
import 'HELPDESK/Components/ModuleCertification/ModuleCertification.css';
import config from 'config';
import HelpdeskApiCall from 'HelpdeskApiCall';
import SuccessModal from 'HELPDESK/CommonResources/SuccessModal/SuccessModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLoader from 'HELPDESK/CommonResources/ButtonLoader/ButtonLoader';
import CertificateDetails from '../ModuleCertification/CertificateDetails/CertificateDetails';
import CertificateList from '../ModuleCertification/CertificateList/CertificateList';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ReactHtmlParser from 'react-html-parser';
import Pagination from 'react-js-pagination';
import DeleteTextModal from 'HELPDESK/CommonResources/DeleteTextModal/DeleteTextModal';
import ReactToPrint from 'react-to-print';

class ModuleCertification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // VARIABLES TO GET MODULE LIST
            moduleFetching: false,
            moduleList: {},

            //VARIABLES FOR ADD CERTIFICATION
            selectedLanguage:[],
            certificationAvailableLanguage:["English","Hindi","Marathi","Telugu","Kannada","Malayalam"],
            addingCertificate:false,
            moduleWarning:'',
            languageWarning:'',
            moduleId:'',

            //VARIABLE TO SHOW CERTIFICATION CONTENT PAGE
            showCertificationContent:false,
            currentTab:'certification',
            certificationModuleId:'',
            certificationId:'',
            UpdateSelectedLanguageArray:false,
            selectedLanguageArray:[],

            //VARIABLE TO VIEW CERTIFICATE LIST
            certificateCurrentTab: 'certified',
            isDeleted:false,

        };
    }

    componentDidMount() {
       // API CALL METHOD TO GET MODULE DETAILS
       this.apiCallToGetModuleList();
    }

    // API CALL METHOD TO GET MODULE LIST
    apiCallToGetModuleList = async () => {
        this.setState({
            moduleFetching: true
        });

        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetHelpDeskModuleList',
            requestData,
            '/api/helpDesk/employee/moduleInformation.php'
        );
        
        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetModuleList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    moduleFetching: false,
                    moduleList: apiResult
                });
            } else {
                this.setState({
                    moduleFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting module list. Please try again later.'
                });
            }
        }
    }
    // METHOD TO GET MODULE
    getModule = (e) => {
        this.setState({
            moduleId: e.target.value
        });
        if(e.target.value.length < 1) {
            this.setState({
                moduleWarning: 'Please select module.',
                moduleName: ''
            });
        }else {
            this.setState({
                moduleWarning: '',
                moduleName: e.target.selectedOptions[0].text
            });
        }
    }
     
    // METHOD TO SELECT Language
    selectAddCertificationLanguage = (language) => {
     
        let selectedLanguage = this.state.selectedLanguage;

        if(selectedLanguage.includes(language)) {
            selectedLanguage = selectedLanguage.filter(name => name != language);
        }else {
            selectedLanguage.push(language);
        }
        if(selectedLanguage.length<1)
        {
            this.setState({
                languageWarning: 'Please select language.',
            })
        }else{
            this.setState({
                languageWarning: '',
            })
        }

        this.setState({
            selectedLanguage
        });
    }

    // METHOD TO VALIDATE CERTIFICATION DETAILS
    validateCertificationDetails = () => {
        let validData = true;
        
        if(this.state.moduleId.length < 1) {
            this.setState({
                moduleWarning: 'Please select module.'
            });
            validData = false;
        }  

        if(this.state.selectedLanguage.length < 1) {
            this.setState({
                languageWarning: 'Please select language.'
            });
            validData = false;
        }
        if(validData) {
            // METHOD CALLED TO ADD CERTIFICATE
            this.apiCallToAddCertificate();
        }
    }


    // API CALL METHOD TO ADD CERTIFICATE
    apiCallToAddCertificate = async () => {
        this.setState({
            addingCertificate: true
        });

        let requestData = {
            "iid": config.institute_id,
            "module_id": this.state.moduleId,
            "certification_language_array": this.state.selectedLanguage,
            "facultyId": config.faculty_id
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'AddHelpDeskModuleCertification',
            requestData,
            '/api/helpDesk/employee/moduleCertification.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToAddCertificate()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if(apiResult.status == 'success') {
                    // let coordinatorList = this.state.coordinatorList;
                    // let moduleList = this.state.moduleList;
                    // let employeeList = this.state.employeeList;
                    // if(coordinatorList[this.state.selectedModule] == undefined) {
                    //     coordinatorList[this.state.selectedModule] = {};
                    //     coordinatorList[this.state.selectedModule]["moduleId"] = this.state.selectedModule;
                    //     coordinatorList[this.state.selectedModule]["moduleName"] = moduleList[this.state.selectedModule]["module_name"];
                    //     coordinatorList[this.state.selectedModule]["coordinatorObj"] =[];
                    // }
                 
                    
                    this.setState({
                        addingCertificate: false,
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                        showCertificationContent:true,     
                        certificationModuleId:this.state.moduleId,
                        certificationId:apiResult.UID,                  
                    });
                    this.closeAddCertificate();
                }else {
                    this.setState({
                        addingCertificate: false,
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message
                    });
                }
            } else {
                this.setState({
                    coordinatorFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while adding certificate. Please try again later.'
                });
            }
        }
    }

    // METHOD TO CLOSE ADD COORDINATOR
    closeAddCertificate = () => {
        this.setState({
            addingCertificate: false,
            moduleId:'',            
            moduleWarning:'',
            languageWarning:'',
            selectedLanguage:[],

        });
    }
    
    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false,
        });
    }

    //show certificate details
    showCertificateDetailsComponent = (certificate) =>{
        this.setState({
            showCertificationContent:true,
            currentTab:'certification',
            certificationModuleId:certificate.module_id,
            certificationId:certificate.uniqueid,
            UpdateSelectedLanguageArray:false,
            selectedLanguageArray:certificate.supportingLanguageArray
        })
    }

    // API CALL METHOD TO DELETE ACTIVITY
    apiCallToDeleteCertificate = async () => {
        let requestData = {
            "moduleCertificationId": this.state.certificationId,
            "iid":config.institute_id
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'DeleteHelpDeskModuleCertification',
            requestData,
            '/api/helpDesk/employee/moduleCertification.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToDeleteCertificate()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if(apiResult.status == 'success') {
                    

                    this.setState({
                        responseMessage: apiResult.message,
                        responseType: 'success',
                        isDeleted:true,
                        showCertificationContent:false,
                        selectedLanguageArray:[],
                        certificationId:'',
                        UpdateSelectedLanguageArray:false,

                    });
                }else {
                    this.setState({
                        responseMessage: apiResult.message,
                        responseType: 'warning',
                    });
                }
            } else {
                this.setState({
                    responseMessage: 'Something went wrong while deleting certificate. Please try again later.',
                    responseType: 'error',
                });
            }
        }
    }
    

    render() {
        
        return (
            <>
            {
                this.state.showCertificationContent ? 
                <>
                    <div className="col-md-12 ">
                        <div className="col-md-12 certificationComponent" style={{display:"flex",alignItems:'center'}}>
                            <span className="certificationIconContainer">
                                <FontAwesomeIcon color="#0465AC" icon={['fas', 'arrow-alt-circle-left']} style={{ cursor: 'pointer', fontSize: 26 }} onClick={() => this.setState({showCertificationContent:false})} />
                            </span>
                            <div className="components-link col-md-10">
                                <div 
                                    className={this.state.currentTab == 'certification' ? 'selectedTab certification' : 'inactive certification'}
                                    onClick={() => this.setState({ currentTab: 'certification' })}
                                >
                                    Certification
                                </div>
                                {/* <div 
                                    className={this.state.currentTab == 'trainingDelivered' ? 'selectedTab trainingDelivered' : 'inactive trainingDelivered'}
                                    onClick={() => this.setState({ currentTab: 'trainingDelivered' })}
                                >
                                    Training Delivered
                                </div> */}
                            </div>
                            <div className="col-md-2">
                            {
                                !this.state.UpdateSelectedLanguageArray
                                &&
                                <span style={{color:"#0465ac"}}>
                                    <span className="">
                                        <FontAwesomeIcon icon={['fas', 'pen']} style={{  cursor: 'pointer' }} onClick={() => this.setState({UpdateSelectedLanguageArray: true})} /> <span style={{marginRight:10,fontWeight:"bold"}}>Edit</span> 
                                    </span>
                                    <span class="dropdown">
                                        <FontAwesomeIcon icon={['fas', 'trash']} style={{ cursor: 'pointer' }} data-toggle="dropdown"  /> <span style={{marginRight:10,fontWeight:"bold"}}>Delete</span>
                                        <div class="dropdown-menu deleteMenu" aria-labelledby="dropdownMenuButton">
                                            <p style={{ fontSize: 14 }}>Are you sure you want to delete certificate?</p>
                                            <div className="level-buttons">
                                                <button className="btn primary-button inlineDelete" onClick={() => this.apiCallToDeleteCertificate()}>Yes</button>
                                                <button className="btn outline-button inlineDelete">No</button>
                                            </div>
                                        </div>
                                    </span>
                                </span>
                            }
                            </div>
                        </div>
                        <div className="component-container col-md-12">
                            {
                                this.state.currentTab == 'certification' ?
                                <CertificateDetails 
                                    certificationModuleId= {this.state.certificationModuleId}
                                    certificationId= {this.state.certificationId}
                                    UpdateSelectedLanguageArray={this.state.UpdateSelectedLanguageArray}
                                    selectedLanguageArray={this.state.selectedLanguageArray}
                                />
                                :
                                <></>
                            }
                        </div>
                    </div>
                </>
                :
                <div className="moduleCertificationContainer col-md-12">
                    <div className="link-header">
                        {/* <FontAwesomeIcon icon={['far', 'arrow-alt-circle-left']} size="lg" style={{ marginRight: 10, cursor: 'pointer' }} onClick={() => this.props.closeLinkDetails()} /> */}
                        <p className="header-text">Module Certification</p>
                    </div>
                    <div className="add-certificationContainer col-md-12">
                        <div className="col-md-6 ">
                            <p className="getCertifiedHeader">Get Certified</p>
                            <p className="getCertifiedBody">Select the module in which you want to get certified to train others.</p>
                        </div>
                        <div className="col-md-4 add-certification">
                            <div className="addCertificationModule">
                                <select
                                    className="form-control addQueryInput"
                                    value={this.state.moduleId}
                                    onChange={(e) => this.getModule(e)}
                                >
                                    <option value="">Select Module</option>
                                    {
                                        Object.keys(this.state.moduleList).length > 0 &&
                                            Object.values(this.state.moduleList).map(module => {                                           
                                                return(
                                                    <option key={module.moduleId} value={module.moduleId}>{module.module_name}</option>
                                                );
                                                    
                                            })
                                    }
                                </select>
                                <p className="text-danger" style={{ fontSize: 14 }}>{this.state.moduleWarning}</p>
                            </div>
                            <div className="addCertificationLanguage" style={{marginTop:10}}>
                                <div className="dropdown">
                                    <input
                                        type="text"
                                        className="form-control addQueryInput"
                                        placeholder='Click to select language'
                                        data-toggle="dropdown"
                                        readOnly
                                    />
                                    <div id="languageDropdown" className="dropdown-menu">
                                        {                                          
                                            this.state.certificationAvailableLanguage.map(language => {
                                                return (
                                                    <p className="dropdown-item languageItem" style={{ display: 'flex' }} key={language} onClick={() => this.selectAddCertificationLanguage(language)}>
                                                        <input
                                                            type='checkbox'
                                                            checked={this.state.selectedLanguage.includes(language)}
                                                            style={{ marginRight: 10 }}
                                                        />
                                                        <span>{language}</span>
                                                    </p>
                                                );
                                            })                                            
                                        }
                                    </div>
                                    <span style={{'font-size':'13px'}}>{this.state.selectedLanguage.join(', ') }</span>
                                </div>
                                <p className="text-danger" style={{ fontSize: 14 }}>{this.state.languageWarning}</p>
                            </div>
                            <div>
                                {
                                    this.state.addingCertificate &&
                                        <ButtonLoader />
                                }
                                <div className="getCertifiedButton btn" onClick={() => this.validateCertificationDetails()} disabled={this.state.addingCertificate} >Get Certified</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 " style={{padding:0}}>
                        <div className="col-md-12 certificationComponent" style={{display:"flex"}}>                           
                            <div className="components-link ">
                                <div 
                                    className={this.state.certificateCurrentTab == 'certified' ? 'selectedTab certified' : 'inactive certified'}
                                    onClick={() => this.setState({ certificateCurrentTab: 'certified' })}
                                >
                                    Certified Modules
                                </div>
                                {/* <div 
                                    className={this.state.certificateCurrentTab == 'trainingDelivered' ? 'selectedTab trainingDelivered' : 'inactive trainingDelivered'}
                                    onClick={() => this.setState({ certificateCurrentTab: 'trainingDelivered' })}
                                >
                                    Training Delivered
                                </div> */}
                            </div>
                        </div>
                        <div className="component-container ">
                            {
                                this.state.certificateCurrentTab == 'certified' ?
                                    <CertificateList
                                        showCertificateDetailsComponent={this.showCertificateDetailsComponent}
                                        deletedCertificateId = {this.state.certificationId}
                                        isDeleted = {this.state.isDeleted}
                                    />
                                :
                                    <>

                                    </>
                            }
                        </div>
                    </div>
                </div>
            }
                
            {
                this.state.successModal &&
                    <SuccessModal
                        successModal={this.state.successModal} 
                        successModalType={this.state.successModalType}
                        successMessage={this.state.successMessage}
                        closeSuccessModal={this.closeSuccessModal} 
                    />
            }
            <br/>
           
        </>
        );
    }
}

export default ModuleCertification;